// from 10;;100 returns [10, -1, 100]
function parseISIValue(isiValue) {
	var isi = isiValue.split(';');
	var isiValues = [];

	for (var i = 0; i < isi.length; i++) {
		var arrValues = parseMultiplyValue(isi[i]);

		if (arrValues) {
			isiValues = isiValues.concat(arrValues);
		} else {
			var intValue = computeRandomSelection(isi[i]);
			isiValues.push(isNaN(intValue) ? -1 : intValue);
		}
	}

	return isiValues;
}

//returns isiTimes as array by filtering all values < 0
function computeISITimes(isiValues) {
	var isiTimes = [];
	for (var i = 0; i < isiValues.length; i++) {
		if (isiValues[i] >= 0) {
			isiTimes.push(isiValues[i]);
		}
	}

	return isiTimes;
}


// isi - aray of isi values
// stimuliNumber, the total number of stimuli
// returns an array with the number of stimuli for each screen
function computeStimuliCountForSreens(isi, stimuliNumber) {
	var screensStimuliCounter = [];
	var screenIndex = 0;

	//first stimulus on first screen
	screensStimuliCounter[screenIndex] = 1;

	//generate ISI + 1 screens but not more than stimuliNumber, screens start from 0
	for (var i = 0; i < isi.length && i+1 < stimuliNumber; i++) {
		if (isi[i] >= 0) {
			screenIndex++;
			screensStimuliCounter[screenIndex] = 0;
		}

		screensStimuliCounter[screenIndex]++;
	}

	//everyhing on one screen
	if (screenIndex == 0) {
		screensStimuliCounter[screenIndex] = stimuliNumber;
	} else {
		// all the rest for the last screen, if anything left to show
		if (stimuliNumber - isi.length > 0) {
			screensStimuliCounter[screenIndex] = stimuliNumber - isi.length;
		}
	}

	return screensStimuliCounter;
}

// returns an array of presentation times for each screen and adds -1 to the last one if no value found
function parsePresTimeValue(presTimeValue, screenNumber, presTime2Value) {
	var presTime = presTimeValue.split(';');
	var presTimeValues = [];

	for (var i = 0; i < presTime.length; i++) {
		var arrValues = parseMultiplyValue(presTime[i]);

		if (arrValues) {
			presTimeValues = presTimeValues.concat(arrValues);
		} else {
			var intValue = computeRandomSelection(presTime[i]);
			if (!isNaN(intValue)) {
				presTimeValues.push(intValue);
			}
		}
	}

	//legacy support
	if (presTime2Value && presTime2Value != 'na') {
		var intPresTime2 = parseInt(presTime2Value);
		if (!isNaN(intPresTime2)) {
			presTimeValues[1] = intPresTime2;
		}
	}

	//add indefinite time for last screen
	if (presTimeValues.length < screenNumber) {
		presTimeValues.push(-1);
	}

	return presTimeValues;
}

function initScreensTimingData(isiValue, presTimeValue, stimuliNumber, withTarget, presTime2Value) {
	var isi = parseISIValue(isiValue);
	var isiTimes = computeISITimes(isi);
	var screenStimuliCounter = computeStimuliCountForSreens(isi, stimuliNumber);
	var screensNumber = screenStimuliCounter.length;
	var presTimes = parsePresTimeValue(presTimeValue, screensNumber, presTime2Value);
	var screensTimingData = [];

	console.log('screenStimuliCounter', screenStimuliCounter);
	console.log('number of screens ', screensNumber, isiTimes.length, screenStimuliCounter.length, presTimes.length);
	console.log('isi', isi);

	for (var i = 0; i < screensNumber; i++) {
		screensTimingData.push({
			'startStimuliIndex': screensTimingData[i - 1] ? screensTimingData[i - 1].startStimuliIndex + screensTimingData[i - 1].stimuliNumber : 0,
			'stimuliNumber': screenStimuliCounter[i],
			'isi': isiTimes[i] ? isiTimes[i] : 0,
			'presTime': presTimes[i] > 0 ? presTimes[i] : 0
		});

		if (withTarget && i == 0) {
			screensTimingData[i].stimuliNumber--;
		}
	}

	return screensTimingData;
}


function hasMultipleStimuliOnAnyScreen(screensTimings) {

	if (!screensTimings || screensTimings.length == 0) {
		return false;
	}

	for (var i = 0; i < screensTimings.length; i++) {
		if (screensTimings[i].stimuliNumber > 1) {
			return true;
		}
	}

	return false;
}

function trialHasManyScreens(screensTimings) {
	return screensTimings.length > 1;
}

function trialScreenHasMultipleStimuli(screensTimings, trialRow, screenIndex) {
	if (screensTimings[trialRow] && screensTimings[trialRow][screenIndex]) {
		return screensTimings[trialRow][screenIndex].stimuliNumber > 1;
	}

	return false;
}

//returns true of any screen after startScreenIndex (including) has more stimuli
function trialHasMultipleStimuliOnAnyScreenStartingWith(screensTimings, trialRow, startScreenIndex) {

	if (screensTimings[trialRow]) {
		var trial = screensTimings[trialRow];

		for (var screenIndex = startScreenIndex; screenIndex < trial.length; screenIndex++) {
			if (trialScreenHasMultipleStimuli(screensTimings, trialRow, screenIndex)) {
				return true;
			}
		}
	}

	return false;
}

function trialHasManyScreens(screenTimings) {
	return screenTimings.length > 1;
}

function isTargetAlone(trialRow) {
	var targetScreenTimings = listTrialScreensTimings[trialRow][0];
	return targetScreenTimings.stimuliNumber == 0;
}

function hasTarget(trialRow) {
	return columnForTrial('target', trialRow) != "na";
}

function parseMultiplyValue(value) {
	var regExp = /^(\d+f?)\*(\d+)$/;
	var matches = value.match(regExp);
	if (matches) {
		var intervalValue = parseInt(matches[1]);
		var numberOfIntervals = parseInt(matches[2]);
		var arr = [];

		for (var i = 0; i < numberOfIntervals; i++) {
			arr.push(intervalValue);
		}

		return arr;
	}

	return null;
}